import axiosClient from "./axios";

export const getUniverseEvents = async (year, month) => {
    try {
        const response = await axiosClient.get("/module/universe-guide", {
            params: { year, month }
        });
        return response.data;
    } catch (error) {
        console.error("Evren rehberi verisi alınırken hata:", error);
        throw error;
    }
};

export const interpretUniverseEvent = async (eventType, eventId) => {
    try {
        const response = await axiosClient.post("/module/universe-guide/interpret", {
            event_type: eventType,
            event_id: eventId
        });
        return response.data;
    } catch (error) {
        console.error("Olay yorumlanırken hata:", error);
        throw error;
    }
};

export const reportUniverseEventError = async (eventType, eventId, errorMessage = "", userNote = "") => {
    try {
        const response = await axiosClient.post("/module/universe-guide/report", {
            event_type: eventType,
            event_id: eventId,
            error_message: errorMessage,
            user_note: userNote
        });
        return response.data;
    } catch (error) {
        console.error("Hata bildirilirken hata oluştu:", error);
        throw error;
    }
};
